/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Cell, Grid } from 'react-md';
import { find, get, range } from 'lodash-es';

// import PercentField from '../../Common/PercentField';
import HiddenField from '../../Common/HiddenField';
import Select from '../../Common/Select';
import TextField from '../../Common/TextField';
import BankSelect from './BankSelect';

class BillingFieldsComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedBillingMode: undefined,
      selectedValue: undefined,
      selectedIbanValue: undefined,
      initialBillingModeValue: undefined,
      bic: undefined,
      debitDayOptions: undefined,
      selectedValueDebitDay: undefined,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { billingModes, values, defaultValues } = prevProps;
    const { initialBillingModeValue, selectedBillingMode, selectedIbanValue, bic } = prevState;

    if (typeof initialBillingModeValue === 'undefined' && billingModes.length > 0) {
      let newBillingMode = billingModes[0].id;

      if (defaultValues?.billingMode) {
        const defaultBilingMode = find(billingModes, { code: defaultValues.billingMode });

        if (defaultBilingMode) {
          newBillingMode = defaultBilingMode.id;
        }
      }

      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ initialBillingModeValue: newBillingMode });
    }

    if (typeof selectedIbanValue === 'undefined' && get(values, 'iban', false)) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ selectedIbanValue: values.iban, bic: values.bic });
    }
    if (typeof bic === 'undefined' && get(values, 'bic', false)) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ bic: values.bic });
    }
    if (values && typeof selectedBillingMode === 'undefined' && typeof initialBillingModeValue !== 'undefined') {
      if (values.billing_mode) {
        this.changeBillingMode(values.billing_mode);
      } else {
        this.changeBillingMode(initialBillingModeValue);
      }
    }
  }

  changeBillingMode = value => {
    this.setState((prevState, props) => {
      const { selectedBillingMode, selectedValueDebitDay } = prevState;
      if (selectedBillingMode && selectedBillingMode.id === value) {
        return undefined;
      }
      const { billingModes, defaultValues, formApi, index } = props;
      const billingMode = billingModes.find(x => x.id === value);

      const debitDayOptions = (get(billingMode, 'allowed_direct_debit_days') || range(1, 29).join(','))
        .split(',')
        .map(x => {
          const debitDay = x.trim();
          return { value: parseInt(debitDay, 10), text: debitDay };
        });

      let newSelectedValueDebitDay = selectedValueDebitDay;

      if (debitDayOptions.length === 1) {
        newSelectedValueDebitDay = debitDayOptions[0].value;
      } else if (!find(debitDayOptions, x => `${x.value}` === `${selectedValueDebitDay}`)) {
        if (find(debitDayOptions, x => `${x.value}` === `${defaultValues.allowed_direct_debit_day}`)) {
          newSelectedValueDebitDay = defaultValues.allowed_direct_debit_day;
        } else {
          newSelectedValueDebitDay = debitDayOptions[0].value;
        }
      }

      if (formApi && index !== null && index !== undefined) {
        const newFormState = {
          ...formApi.getState(),
        };
        newFormState.values.subscriptions[index].allowed_direct_debit_day = newSelectedValueDebitDay;

        formApi.setState(newFormState);
      }

      return {
        selectedBillingMode: billingMode,
        debitDayOptions,
        selectedValueDebitDay: newSelectedValueDebitDay,
      };
    });
  };

  render() {
    const { ...props } = this.props;
    // eslint-disable-next-line no-unused-vars
    const { billingModes, strings, defaultValues, banks, readOnly } = props;
    const {
      selectedBillingMode,
      // selectedIbanValue,
      selectedValue,
      initialBillingModeValue,
      bic,
      debitDayOptions,
      selectedValueDebitDay,
    } = this.state;

    const billingOptions =
      Array.isArray(billingModes) && billingModes.length > 0
        ? billingModes.map(billingMode => {
            const { id: value, name: text } = billingMode;
            return { value, text };
          })
        : [];

    const directDebit = !!(selectedBillingMode && selectedBillingMode.direct_debit);

    const validateIBAN = value => {
      if (!value || value.trim() === '')
        return get(strings, 'validation.field.required', 'This field is a required field');
      if (!value || (value >= 16 && value <= 31))
        return get(strings, 'validation.field.invalidiban', 'Invalid IBAN number');
      return null;
    };
    const currentIban = get(this.state, 'validateIban', {});

    const getBicField = () => {
      if (typeof currentIban.status === 'undefined' && typeof bic === 'undefined') return undefined;

      return currentIban.status || (typeof currentIban.status === 'undefined' && typeof bic !== 'undefined') ? (
        <TextField
          className="field text"
          key="bic"
          field="bic"
          id="field-bic"
          name="bic"
          shrink
          label={strings['block.transform.party.field.bic.label']}
          placeholder=""
          onChange={value => this.setState({ selectedValue: value })}
          value={currentIban.bic}
          initialValue={currentIban.bic}
          disabled={readOnly}
        />
      ) : (
        <BankSelect
          key="bic"
          field="bic"
          id="bic"
          name="bic"
          label={strings['block.transform.party.field.bic.label']}
          placeholder=""
          required
          onChange={value => this.setState({ selectedValue: value, bic: value })}
          value={bic}
          options={Array.isArray(banks.options) ? banks.options : []}
          type="banks"
          style={{
            minWith: '200px',
          }}
          disabled={readOnly}
        />
      );
    };

    return selectedBillingMode ? (
      <>
        <Grid className="grid billing" style={{ width: '100%' }}>
          <Select
            className="field select"
            key="billing_mode"
            field="billing_mode"
            id={`select-${'billing_mode'}`}
            name="billing_mode"
            shrink
            label={strings['block.transform.party.field.billing_mode.label']}
            options={billingOptions}
            onChange={value => this.changeBillingMode(value)}
            value={selectedValue || selectedBillingMode.id}
            initialValue={selectedBillingMode.id || initialBillingModeValue}
            disabled={readOnly}
          />
          <HiddenField field="direct_debit" value={directDebit} initialValue={directDebit} />
        </Grid>
        <Grid className="grid billing" style={{ width: '100%' }}>
          {selectedBillingMode && selectedBillingMode.direct_debit ? (
            <>
              <div
                key="allowed_direct_debit_day"
                className={Cell.getClassName({ size: 2 })}
                style={{ minWidth: '130px', display: debitDayOptions.length > 1 ? 'block' : 'none' }}
              >
                <Select
                  className="field select"
                  key="allowed_direct_debit_day"
                  field="allowed_direct_debit_day"
                  id="select-allowed_direct_debit_day"
                  name="allowed_direct_debit_day"
                  shrink
                  label={strings['block.transform.party.field.allowed_direct_debit_day.label']}
                  options={debitDayOptions}
                  onChange={value => this.setState({ selectedValueDebitDay: value })}
                  value={selectedValueDebitDay}
                  initialValue={defaultValues.allowed_direct_debit_day}
                  disabled={readOnly}
                />
              </div>
              <div
                key="iban"
                className={Cell.getClassName({ size: debitDayOptions.length > 1 ? 6 : 12 })}
                style={{ display: 'flex', flexDirection: 'column' }}
              >
                <div className="block row">
                  <TextField
                    className="field text"
                    key="iban"
                    field="iban"
                    id="field-iban"
                    name="iban"
                    shrink
                    label={strings['block.transform.party.field.iban.label']}
                    placeholder=""
                    onChange={value => this.setState({ selectedIbanValue: value })}
                    value={selectedValue}
                    validate={validateIBAN}
                    disabled={readOnly}
                  />
                </div>
                <span className={typeof currentIban.status === 'undefined' || currentIban.status ? 'valid' : 'invalid'}>
                  {currentIban.message}
                </span>
              </div>
              <div
                key="bic"
                className={Cell.getClassName({ size: 4 })}
                style={{ display: 'flex', flexDirection: 'column' }}
              >
                {getBicField()}
              </div>
            </>
          ) : undefined}
        </Grid>
      </>
    ) : (
      ''
    );
  }
}

BillingFieldsComponent.propTypes = {
  billingModes: PropTypes.array, // eslint-disable-line
  logout: PropTypes.func, // eslint-disable-line
  formApi: PropTypes.any, // eslint-disable-line
  index: PropTypes.number, // eslint-disable-line
  data: PropTypes.array, // eslint-disable-line
  type: PropTypes.string, // eslint-disable-line
  onSave: PropTypes.func, // eslint-disable-line
  strings: PropTypes.object.isRequired, // eslint-disable-line
  classes: PropTypes.any, // eslint-disable-line
  banks: PropTypes.any.isRequired, // eslint-disable-line
  defaultValues: PropTypes.object, // eslint-disable-line
};

BillingFieldsComponent.defaultProps = {
  billingModes: [],
  defaultValues: {
    allowed_direct_debit_day: 5,
  },
};

export default BillingFieldsComponent;
